import { render, staticRenderFns } from "./Donasi.vue?vue&type=template&id=3c9ce602&"
import script from "./Donasi.vue?vue&type=script&lang=js&"
export * from "./Donasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports